var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3User(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/3 User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M17.5948 11.7687C19.1972 11.7687 20.497 10.4698 20.497 8.86745C20.497 7.26512 19.1972 5.9662 17.5948 5.9662",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M18.9291 14.9216C19.4076 14.9546 19.8833 15.0224 20.3517 15.1278C21.0026 15.2552 21.7854 15.522 22.0641 16.1059C22.2419 16.4799 22.2419 16.9153 22.0641 17.2902C21.7863 17.8742 21.0026 18.14 20.3517 18.2738",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M6.28998 11.7687C4.68765 11.7687 3.38782 10.4698 3.38782 8.86745C3.38782 7.26512 4.68765 5.9662 6.28998 5.9662",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M4.95577 14.9216C4.47727 14.9546 4.00152 15.0224 3.5331 15.1278C2.88227 15.2552 2.09943 15.522 1.82168 16.1059C1.64293 16.4799 1.64293 16.9153 1.82168 17.2902C2.09852 17.8742 2.88227 18.14 3.5331 18.2738",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9377 15.5464C15.1846 15.5464 17.9584 16.0377 17.9584 18.004C17.9584 19.9693 15.2029 20.479 11.9377 20.479C8.68997 20.479 5.91705 19.9876 5.91705 18.0214C5.91705 16.0551 8.67255 15.5464 11.9377 15.5464Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9377 12.7417C9.79638 12.7417 8.07947 11.0248 8.07947 8.88257C8.07947 6.74124 9.79638 5.02432 11.9377 5.02432C14.0791 5.02432 15.796 6.74124 15.796 8.88257C15.796 11.0248 14.0791 12.7417 11.9377 12.7417Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3User);
export default __webpack_public_path__ + "static/media/3-user.313d0d6004a6d07f1b20487503a16ff3.svg";
export { ForwardRef as ReactComponent };